import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { BookingSummaryRow } from '../interfaces/bookings.interface';

export const bookingsApi = {
  async get(companyId?: number, direction?: ShippingDirection): Promise<BookingSummaryRow[]> {
    const params: Record<string, string | number> = {};
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/dashboard/bookings-summary', { params });
    return (response.data?.data as BookingSummaryRow[]) ?? [];
  },
};
